import { gql } from 'apollo-boost';

const manyQuery = gql`
  query statistics($inputFilter: CertificationsAthleteFilterInputType) {
    statistics(inputFilter: $inputFilter) {
      rank
      countAthletes
      countDealing
      countReDealing
      countPassed
      countNotPass
    }
  }
`;

export const deleteMutation = gql`
  mutation deleteProtocol($rank: String!, $certificationId: Int!) {
    deleteProtocol(rank: $rank, certificationId: $certificationId) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

const STATISTICS = {
  manyQuery,
  deleteMutation,
};

export default STATISTICS;
